import { twMerge } from "tailwind-merge";

import { faBookmark } from "@fortawesome/free-regular-svg-icons/faBookmark";
import { faBookmark as faBookmarkSolid } from "@fortawesome/free-solid-svg-icons/faBookmark";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import { useInsightInteractions } from "hooks/useInsightInteractions";
import useMediaQuery from "hooks/useMediaQuery";

type Props = {
  publication: any; // insight or locker item
  iconOnly?: boolean;
  className?: string;
};

const PublicationSaveButton = ({ publication, iconOnly, className }: Props) => {
  const { mobile } = useMediaQuery();

  const { isSaved, save } = useInsightInteractions({
    insight: publication,
    lockerItem: publication.asset ? publication : null,
  });

  return (
    <div
      className={twMerge(
        "cursor-pointer",
        "text-intelligent-silver hover:text-active-black",
        className
      )}
      onClick={save}
    >
      <FontAwesomeIcon
        icon={isSaved ? faBookmarkSolid : faBookmark}
        className="mr-[5px]"
      />
      {mobile || iconOnly ? "" : isSaved ? " Saved" : " Save"}
    </div>
  );
};

export default PublicationSaveButton;
